import React from 'react';

function BlankHome() {
  return <div style={{ minHeight: '100vh', background: '#ffffff' }} />;
}

export default BlankHome;
